<template>
  <el-dialog
    :title="getTitle() ?'Create Location':'Edit Location'"
    :visible.sync="isShowing"
    width="60%"
    :fullscreen="isFullscreen"
  >
    <LocationForm
      ref="locationForm"
      :form="form"
    />
    <span
      slot="footer"
      class="dialog-footer"
    >

      <el-button @click.native="isFullscreen = !isFullscreen">
        <FontAwesomeIcon
          v-if="isFullscreen"
          :icon="['fal', 'compress']"
        />
        <FontAwesomeIcon
          v-else
          :icon="['fal', 'expand']"
        />
      </el-button>
      <el-button @click.native="isShowing = false">
        Cancel
      </el-button>

      <el-button
        type="primary"
        :loading="isSaving"
        @click.native="create"
      >
        Save
      </el-button>
    </span>
  </el-dialog>
</template>

<script>
import LocationForm from '@/components/Application/Manage/Locations/LocationForm'
export default {
  components: {
    LocationForm
  },
  props: {
    form: {
      type: Object,
      required: true
    },
    operator: {
      type: Boolean,
      required: true
    }
  },
  data () {
    return {
      isShowing: false,
      isFullscreen: false,
      isSaving: false
    }
  },
  methods: {
    getTitle () {
      if (this.operator) {
        return true
      }
      return false
    },
    showForm () {
      this.isShowing = true
    },
    closeForm () {
      this.isShowing = false
      this.isSaving = false
    },
    create () {
      if (this.operator) {
        this.$refs.locationForm.$refs.lform.validate((validate) => {
          if (validate) {
            this.isSaving = true
            this.$emit('save')
          }
        })
      } else {
        this.isSaving = true
        this.$emit('update')
      }
    }
  }
}
</script>

<style>

</style>
